// src/components/Header.tsx

import { useNavigate } from 'react-router-dom';
import { useAppStore } from '../store/appStore';

export function Header() {
  const logout = useAppStore((state) => state.logout);
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  return (
    <header className="app-header">
      <h1 className="app-title">JAW Photos</h1>
      <button className="logout-button" onClick={handleLogout} type="button">
        Logout
      </button>
    </header>
  );
}
